import styled from "styled-components";

import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";
import { greyMui, MOBILE_BREAKPOINT, rydeColors } from "@ryde/theme";

import { TitleLineStyled } from "../../login/login.page.styled";

// styled.main: the page is a top-level route with no <main> ancestor in App, and every page must expose
// exactly one main landmark. grid-area: it shares the login page grid (MainLoginContainerStyled); without
// it the grid auto-places this element into the first cell, underneath the illustration.
export const McpConnectorActionFormStyled = styled.main.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "mcp-connector-action-form",
  },
)`
  grid-area: loginform;
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .actionCard {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .requestedBy {
    font-size: 15px;
    line-height: 1.5;
    margin: 0;
  }

  .summaryTitle {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.4;
    margin: 0;
  }

  .summaryLines {
    margin: 0;
    padding-inline-start: 20px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 14px;
    max-height: 320px;
    overflow-y: auto;
  }

  .timeLeft,
  .nothingChangesYet {
    font-size: 13px;
    color: ${rydeColors.steel};
    margin: 0;
  }

  .details {
    font-size: 13px;

    /* The native list-item display keeps the disclosure arrow; line-height gives the 44px target. */
    summary {
      cursor: pointer;
      line-height: 44px;
      color: ${greyMui._700};
    }

    summary:focus-visible {
      outline: 2px solid ${rydeColors.steel};
      outline-offset: 2px;
    }

    pre {
      margin: 0;
      padding: 8px;
      max-height: 240px;
      overflow: auto;
      white-space: pre-wrap;
      word-break: break-word;
      text-align: start;
      background: ${greyMui._100};
      border-radius: 4px;
    }
  }

  .actions {
    display: flex;
    gap: 12px;
    margin-top: 8px;

    & > * {
      flex: 1 1 0;
    }
  }

  .statusMessage {
    font-size: 15px;
    text-align: center;
  }

  .errorMessage {
    font-size: 15px;
    text-align: center;
    color: ${greyMui._800};
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    justify-content: center;
    padding-inline-start: 15px;
    padding-inline-end: 15px;
  }
`;

/** The login page's title, under this screen's own data-e2e id. */
export const McpConnectorActionTitleStyled = styled(
  TitleLineStyled,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "mcp-connector-action-title",
})``;
